export default function Marquee() {
  const items = [
    "圧倒的飛距離",
    "3D PRINTED",
    "MADE IN JAPAN",
    "RAIGEKI KAGO",
    "飛ぶ、を極める",
    "PRECISION ENGINEERED",
    "ULTIMATE STABILITY",
    "HAYABUSA WORKS",
  ];
  const loop = [...items, ...items];

  return (
    <div className="w-full bg-primary-500 text-background-50 overflow-hidden py-4 border-y border-primary-600">
      <div className="marquee-track flex items-center gap-10 whitespace-nowrap w-max">
        {loop.map((t, i) => (
          <div key={i} className="flex items-center gap-10">
            <span
              className="text-xl md:text-2xl tracking-[0.3em]"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              {t}
            </span>
            <i className="ri-flashlight-fill text-sm opacity-70"></i>
          </div>
        ))}
      </div>
    </div>
  );
}